import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { getTrip } from "redux/actions/UserTrip";
import MyRideTab from "./MyRideTab";
import RequestRide from "./RequestRide";

function MyRideView() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState("All");
  const type =  searchParams.get('type');
  const handleChange = (event, newValue) => {
    setSearchParams({ type: newValue });
    setValue(newValue);
    setPage(0);
    setRowsPerPage(10)
  };
  useEffect(() =>{
   setValue(type || value)
  },[type])

  const payload = {
    type:'Ride,Rental,Airport,outStation',
    status:'',
    dateFrom:'',
    dateTo:'',
    page:'',
    pageSize:'',
    search:''

  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
      dispatch(getTrip({...payload, status:value === 'All' ? '':value,page: newPage }))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getTrip({...payload, status:value === 'All' ? '':value,page: 0 , pageSize: parseInt(event.target.value) }))
  }
  const onHandleClick = () =>{
  }
  const tripData = useSelector((state) => state.userTrip?.userTrip?.data?.rides);
  const pages = useSelector((state) => state.userTrip?.userTrip?.data);
  const tripLoader = useSelector((state) => state.userTrip?.loading)
  const dispatch = useDispatch();
  useEffect(()=>{
      dispatch(getTrip({...payload, status:value === 'All'? '' : value,page:'',pageSize:'',}))
  },[value])

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, [rowsPerPage,page]);


  return (
    <Grid container justifyContent="center">
      <Grid item md={8.2} xs={12} className="marginRight20">

        <MyRideTab 
        value={value} 
        handleChange={handleChange} 
        handleClick={onHandleClick}
        tripData={tripData}
        page={page}
        totalCount={pages?.totalCount}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        loader={tripLoader}
        /> 
      </Grid>
      <Grid item md={3} xs={10} className="marginTop80">
        <RequestRide />
      </Grid>
    </Grid>
  );
}

export default MyRideView;
